import type { Activity, ActivityType } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function getActivityList({ type }: { type: ActivityType }): Promise<Activity[]> {
  return patientRequestsTyped.get_activity_list({ context: { showLoader: false }, type });
}
